module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vrepr2-28a6488b2d1c434c72191d874ff5b98a.jpg";